<ng-container *transloco="let t">
  <nz-descriptions nzSize="small" [nzColumn]="columns">
    <nz-descriptions-item [nzTitle]="t('name')" [nzSpan]="1">
      {{ contractor?.name }}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('jobTitle')" [nzSpan]="1">
      {{ contractor?.jobTitle }}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('email')" [nzSpan]="1">
      <span [authorityLabsEmailLink]="contractor?.email">{{
        contractor?.email
      }}</span>
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('phone')" [nzSpan]="1">
      {{ contractor?.phone }}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('address')" [nzSpan]="1">
      {{ contractor?.address }}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('companyNumber')" [nzSpan]="1">
      {{ contractor?.companyNumber }}
    </nz-descriptions-item>
  </nz-descriptions>
</ng-container>
